












import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop, Watch } from 'vue-property-decorator'

import { MiniNode } from './types'

@Component
export default class miniNode extends Vue{
  @Prop() nodeEl!: HTMLElement

  @Prop() node!: MiniNode

  @Prop() scale!: number

  settings: {width: string, height: string, x: number, y: number} = {
    width: '',
    height: '',
    x:0,
    y:0,
  }

  @Watch('node')
  nodeWatcher(node: MiniNode) {
    this.settings = {
      x: node.x,
      y: node.y,
      width: `${ this.nodeEl.clientWidth * this.scale }px`,
      height: `${ this.nodeEl.clientHeight * this.scale }px`
    }
  }

  get nodeColor(): string {
    if (this.node.color === 'error') {
      return 'rgb(247, 78, 87)'
    } else {
      // const color = this.node.color ? FlowHelper.getPickerColor(this.node.color) : null

      // return color ? color : 'rgb(51, 153, 255)'
      return 'rgb(51, 153, 255)'
    }
  }

  mounted() {
    this.nodeWatcher(this.node)
  }
}
